export default {
    PESSOAFISICA: 'Pessoa Física',
    PESSOAJURIDICA: 'Pessoa Jurídica'
}